module.exports = __webpack_public_path__ + "fa67f234ccd48691ec54f0cddbb517fb.svg";